<div
  *ngIf="isLoading"
  class="gw-flex gw-flex-col gw-gap-medium gw-max-w-[720px]"
>
  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <div class="gw-flex gw-flex-col gw-gap-small">
      <gatewee-skeleton></gatewee-skeleton>
      <gatewee-skeleton></gatewee-skeleton>
    </div>
  </section>
  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <div class="gw-flex gw-flex-col gw-gap-small">
      <gatewee-skeleton></gatewee-skeleton>
      <gatewee-skeleton></gatewee-skeleton>
      <gatewee-skeleton></gatewee-skeleton>
    </div>
  </section>
</div>

<div
  *ngIf="!isLoading && hasError"
  class="gw-flex gw-flex-col gw-gap-medium gw-max-w-[720px]"
>
  <div class="gw-text-status-negative">
    {{ 'features.profile.error' | translate }}
  </div>
</div>

<div
  *ngIf="!isLoading && profile as user"
  class="gw-flex gw-flex-col gw-gap-medium gw-max-w-[720px]"
>
  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
      {{ 'features.profile.photo.title' | translate }}
    </h2>
    <p class="gw-m-0 gw-mt-2x-small gw-text-sm gw-text-text-secondary">
      {{ 'features.profile.photo.description' | translate }}
    </p>

    <div class="gw-mt-medium gw-flex gw-items-start gw-gap-medium">
      <label
        class="profile-overview-avatar gw-relative gw-shrink-0 gw-cursor-pointer"
        [attr.aria-label]="'features.profile.overview.changePhoto' | translate"
      >
        <input
          type="file"
          class="gw-hidden"
          accept="image/jpeg,image/png"
          [disabled]="uploading"
          (change)="onFileSelected($event)"
        />
        <tui-avatar
          [src]="displayPhotoUrl || (user.name | tuiInitials)"
          [style.background]="
            !displayPhotoUrl ? (user.name | tuiAutoColor) : null
          "
          [round]="true"
          size="l"
        ></tui-avatar>
      </label>

      <div class="gw-min-w-0 gw-flex-1">
        <h3
          class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary gw-truncate"
        >
          {{ user.name }}
        </h3>
        <p class="gw-m-0 gw-mt-2x-small gw-text-xs gw-text-text-secondary">
          {{ 'features.profile.overview.changePhoto' | translate }}
        </p>
      </div>
    </div>

    <div
      *ngIf="hasPreview"
      class="gw-mt-medium gw-rounded-xl gw-border-base gw-bg-background-elevation-2 gw-p-medium"
    >
      <div
        class="profile-overview-preview-row gw-flex gw-flex-col gw-gap-medium sm:gw-flex-row sm:gw-items-center"
      >
        <img [src]="previewUrl" alt="" class="profile-overview-preview" />
        <div class="gw-min-w-0 gw-flex-1">
          <p class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
            {{ 'features.profile.photo.previewTitle' | translate }}
          </p>
          <p class="gw-m-0 gw-mt-4x-small gw-text-xs gw-text-text-secondary">
            {{ 'features.profile.photo.previewHint' | translate }}
          </p>
          <div class="gw-mt-small gw-flex gw-flex-wrap gw-gap-small">
            <gatewee-button
              iconName="@tui.check"
              [title]="'features.profile.photo.confirmUpload' | translate"
              [loading]="uploading"
              [disabled]="uploading"
              (clicked)="confirmUpload()"
            ></gatewee-button>
            <gatewee-button
              variant="secondary"
              iconName="@tui.x"
              [title]="'features.profile.photo.cancelPreview' | translate"
              [disabled]="uploading"
              (clicked)="cancelPreview()"
            ></gatewee-button>
          </div>
        </div>
      </div>
    </div>

    <p
      *ngIf="uploadError"
      class="gw-m-0 gw-mt-small gw-text-sm gw-text-status-negative"
      role="alert"
    >
      {{ uploadError }}
    </p>

    <p class="gw-m-0 gw-mt-small gw-text-xs gw-text-text-secondary">
      {{
        'features.profile.photo.acceptedFormats' | translate : {size: maxSizeMb}
      }}
    </p>
  </section>

  <section
    class="gw-rounded-xl gw-border-base gw-bg-background-elevation-3 gw-p-medium"
  >
    <h2 class="gw-m-0 gw-text-base gw-font-semibold gw-text-text-primary">
      {{ 'features.profile.overview.accountTitle' | translate }}
    </h2>
    <p class="gw-m-0 gw-mt-2x-small gw-text-sm gw-text-text-secondary">
      {{ 'features.profile.overview.accountDescription' | translate }}
    </p>

    <dl
      class="gw-m-0 gw-mt-medium gw-grid gw-grid-cols-1 gw-gap-medium sm:gw-grid-cols-2"
    >
      <div class="gw-flex gw-flex-col gw-gap-2x-small">
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.email' | translate }}
        </dt>
        <dd
          class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary gw-break-words"
        >
          {{ user.email }}
        </dd>
      </div>

      <div class="gw-flex gw-flex-col gw-gap-2x-small">
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.phone' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          <ng-container *ngIf="user.phone?.trim(); else emptyPhone">
            {{ user.phone | phone }}
          </ng-container>
          <ng-template #emptyPhone>—</ng-template>
        </dd>
      </div>

      <div class="gw-flex gw-flex-col gw-gap-2x-small">
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.role' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          {{ user.role | userRole }}
        </dd>
      </div>

      <div *ngIf="user.createdAt" class="gw-flex gw-flex-col gw-gap-2x-small">
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.joinedSince' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          {{ user.createdAt | date : 'mediumDate' }}
        </dd>
      </div>

      <div
        *ngIf="user.domain?.name"
        class="gw-flex gw-flex-col gw-gap-2x-small"
      >
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.domain' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          {{ user.domain?.name }}
        </dd>
      </div>

      <div
        *ngIf="user.recipient?.name"
        class="gw-flex gw-flex-col gw-gap-2x-small"
      >
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.recipient' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          {{ user.recipient?.name }}
        </dd>
      </div>

      <div
        *ngIf="user.recipient?.document"
        class="gw-flex gw-flex-col gw-gap-2x-small"
      >
        <dt class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-secondary">
          {{ 'features.profile.labels.document' | translate }}
        </dt>
        <dd class="gw-m-0 gw-text-sm gw-font-medium gw-text-text-primary">
          {{ user.recipient?.document | document }}
        </dd>
      </div>
    </dl>
  </section>
</div>
